import { createTheme } from "@material-ui/core/styles";
const theme = createTheme({
  palette: {
    primary: {
      main: "#0064AC",
      light: "#04BCD9",
      dark: "#008051",
      contrastText: "#fff"
    },
    secondary: {
      main: "#6c757d"
    },
    tertiary: {
      main: "#0064AC"
    }
  }
});

export default theme;
